import React, { useState } from "react";
import "./FurnitureCards.css";

const cardsData = [
  {
    id: 1,
    title: "Beds",
    category: "LUXURY INTERIOR",
    description:
      "Beautiful handcrafted furniture with timeless aesthetics, premium comfort and elegant modern styling.",
    image:
      "https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?q=80&w=1600&auto=format&fit=crop",
    big: true,
  },

  {
    id: 2,
    title: "Luxury Bed",
    category: "BEDROOM",
    description: "Modern wooden comfort.",
    image:
      "https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?q=80&w=1000&auto=format&fit=crop",
  },

  {
    id: 3,
    title: "Modern Sofa",
    category: "LIVING ROOM",
    description: "Minimal luxury design.",
    image:
      "https://images.unsplash.com/photo-1493663284031-b7e3aefcae8e?q=80&w=1000&auto=format&fit=crop",
  },

  {
    id: 4,
    title: "Dining Table",
    category: "DINING",
    description: "Elegant family dining.",
    image:
      "https://images.unsplash.com/photo-1549187774-b4e9b0445b41?q=80&w=1000&auto=format&fit=crop",
  },

  {
    id: 5,
    title: "Office Desk",
    category: "WORKSPACE",
    description: "Premium workspace furniture.",
    image:
      "https://images.unsplash.com/photo-1519947486511-46149fa0a254?q=80&w=1000&auto=format&fit=crop",
  },
];

export default function FurnitureCards() {

  const [furnitureItems, setFurnitureItems] = useState(cardsData);

  const handleFurnitureCardClick = (clickedFurnitureCard) => {

    if (furnitureItems[0].id === clickedFurnitureCard.id) return;

    const updatedFurnitureCards = [
      clickedFurnitureCard,
      ...furnitureItems.filter(
        (singleFurnitureCard) =>
          singleFurnitureCard.id !== clickedFurnitureCard.id
      ),
    ];

    setFurnitureItems(updatedFurnitureCards);
  };

  return (

    <div className="furniture-wrapper-section container ">

      <h2 className="section-title">
        Why Choose Us
      </h2>

      <p className="exporter-sub">
        Donec vitae odio quis nisl dapibus malesuada.
        Nullam ac aliquet velit.
      </p>

      <section className="furniture-grid-layout">

        {furnitureItems.map((furnitureCard, furnitureIndex) => (

          <div
            key={furnitureCard.id}
            className={`furniture-single-card ${
              furnitureIndex === 0
                ? "furniture-featured-card"
                : "furniture-small-card"
            }`}
            onClick={() =>
              handleFurnitureCardClick(furnitureCard)
            }
          >

            <img
              src={furnitureCard.image}
              alt={furnitureCard.title}
              className="furniture-card-image"
            />

            <div className="furniture-dark-overlay"></div>

            <div className="furniture-arrow-icon">
              ↗
            </div>

            <div className="furniture-card-content">

              <span className="furniture-card-category">
                {furnitureCard.category}
              </span>

              {furnitureIndex === 0 ? (

                <h1 className="furniture-card-title-large">
                  {furnitureCard.title}
                </h1>

              ) : (

                <h2 className="furniture-card-title-small">
                  {furnitureCard.title}
                </h2>

              )}

              <p className="furniture-card-description">
                {furnitureCard.description}
              </p>

              <button className="furniture-explore-button">
                Explore Collection →
              </button>

            </div>

          </div>

        ))}

      </section>

    </div>

  );
}